export default "__VITE_ASSET__CkP4yGub__"